module.exports = __webpack_public_path__ + "img/icono_atras.b7326fa4.svg";